
import Styled from 'styled-components';


export const SelectorBox = Styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--on-surface-dark);
    width: 100%;
    z-index: 100;
    position: relative;
    height: 3.125rem;
    border-top: 1px solid var(--on-primary-dark);
    border-bottom: 1px solid var(--on-primary-dark);
    cursor: pointer;
    //this selector has to be latiendo to show that is a selecto 
    transition: all 0.3s ease-in-out;
    transform: translateX(0);


    
    
    
`;


export const ImgContainer = Styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fafafa;
    height:15rem;
    background-color: var(--on-primary-dark);
    overflow: hidden;
    `;

export const ImgBoxSmall = Styled.div`
    align-self: center;
    position: relative;
    background-color: var(--on-primary-dark);
    z-index: 0;
    overflow: hidden;
    width: 450px;
    height: 380px;
    `;

export const Img = Styled.img<{ step: number }>`
    
    transform: ${({step}) => (step === 1 ? 'translate(100px, 120px)' : step === 2 ? 'translate(-130px, -60px)' : step === 3 ? 'translate(115px, -185px) ' :  step === 4 ? 'translate(-95px, -380px)' : 'translate(0, 0)')}; 
    // set transform with keyframes and step
    transition: transform 0.8s ease-in-out;
    //object-position: ${({step}) => (step === 1 ? '87px 87px' : step === 2 ? '-116px -83px' : step === 3 ? '128px -229px' :  step === 4 ? '-123px -398px' : '0 0')};

    `;

export const DescriptionContainer = Styled.div`
    position:relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    background-color: var(--on-surface-dark);
    padding: 1.875rem 1.25rem 0.625rem;
    `;

export const NumSelectorsBox = Styled.div`
    align-self: flex-start;
    height: 50px;
    width: 25%;
    overflow-y:auto;
    scroll-behavior: smooth;
    scroll-snap-type: y mandatory;
   
    display: flex;
    flex-direction: column;
    align-items: center;
    
    `;
export const NumSelectors = Styled.div`
scroll-padding: 1rem;
font-size: 3rem;
scroll-snap-align: center;
scroll-snap-stop: always;
padding-bottom: 1.5rem;
padding-top:1rem;


`;
export const TextContainer = Styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    gap: 1.25rem;
    `;

export const CardTitle = Styled.h2`
color: var(--on-primary-dark);
min-height: 6.125rem;

`;

export const CardDescription = Styled.p`
color: var(--on-primary-container-light);
`;

export const TextStartNow = Styled.p`
color: var(--on-primary-container-light);
`;
